export default __webpack_public_path__ + "static/media/train.5c2c5bc9.svg";